import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { UsersService } from '../../../pages/pages/users/users.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-view-user-detail',
  templateUrl: './view-user-detail.component.html',
  styleUrl: './view-user-detail.component.scss',
  standalone: false,
})
export class ViewUserDetailComponent implements OnInit, OnDestroy {
  @Input() userId: any;

  userFullName: string = '';
  showSpinner: boolean = false;
  userDetailData: any = {};
  userTags: any = [];

  constructor(
    private userService: UsersService,
    @Optional() protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogueData: any,
  ) {}
  ngOnInit(): void {
    this.userId = this.dialogueData?.userId || this.userId;

    if (this.userId) {
      this.getUserDetails();
    }
  }
  ngOnDestroy(): void {}
  getUserDetails() {
    this.showSpinner = true;
    this.userService
      .getUserById(this.userId, { popover_data: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.showSpinner = false;
          this.userDetailData = response?.data;
          this.userFullName = (this.userDetailData?.full_name || '')?.trim();
          this.userTags = this.userDetailData?.user_tags?.filter(
            (tag: any) => tag,
          );
        } else {
          this.showSpinner = false;
        }
      });
  }
  onCloseDialogue() {
    this.dialogRef.close();
  }
}
